<div class="feedback-section border-round-lg p-4 surface-card shadow-2">
  <h2 class="text-2xl font-medium mb-4">Share Your Feedback</h2>

  <p-messages [(value)]="HTTPResponseMessage" [enableService]="false" styleClass="mb-4"></p-messages>

  <form [formGroup]="feedBackForm" class="field-space-btwn">
    <formly-form [model]="model" [fields]="feedBackFormFields" [form]="feedBackForm"> </formly-form>

    <div class="flex justify-content-end gap-2 mt-4">
      <button
        label="Cancel"
        pButton
        type="button"
        icon="pi pi-times"
        iconPos="left"
        (click)="utilService.goBack()"
        class="p-button-outlined p-button-danger"
      ></button>
      <button
        label="Submit Feedback"
        pButton
        type="button"
        icon="pi pi-send"
        iconPos="left"
        (click)="submitFeedBack()"
        [disabled]="!feedBackForm.valid"
        class="p-button-primary"
      ></button>
    </div>
  </form>
</div>
